import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Youtube } from "lucide-react";

const COLS = [
  {
    title: "Explore",
    links: [
      { to: "/universities", label: "Universities" },
      { to: "/why-australia", label: "Why Australia" },
      { to: "/scholarships", label: "Scholarships" },
      { to: "/guides", label: "Guides" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/#toolkit", label: "Australia Study Toolkit" },
      { to: "/guides", label: "Application Checklist" },
      { to: "/why-australia#faqs", label: "FAQs" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/about", label: "Privacy Policy" },
      { to: "/about", label: "Terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-cream/75 relative grain">
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 py-20">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Link to="/" data-testid="footer-logo" className="flex items-baseline gap-2">
              <span className="font-serif text-4xl font-medium text-cream">Vitaliah</span>
              <span className="h-1.5 w-1.5 rounded-full bg-gold" />
            </Link>
            <p className="mt-6 text-sm leading-relaxed max-w-xs">
              Helping students make more informed decisions about studying in Australia.
            </p>
            <div className="mt-8 flex gap-4" data-testid="footer-social">
              {[Linkedin, Instagram, Facebook, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Social link"
                  data-testid={`footer-social-${i}`}
                  className="p-2 border border-navy-border text-cream/60 hover:text-gold hover:border-gold transition-colors duration-300"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm hover:text-gold transition-colors duration-300"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-navy-border flex flex-col sm:flex-row justify-between gap-4 text-xs text-cream/50">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Vitaliah. Independent education guidance.</p>
          <p>Vitaliah is an independent advisory platform and is not affiliated with any university.</p>
        </div>
      </div>
    </footer>
  );
}
